import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetAnalysisSegmentTeam state domain
 */

const selectWidgetAnalysisSegmentTeamDomain = (state) =>
  state.get("widgetAnalysisSegmentTeam", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingRanks = () =>
  createSelector(selectWidgetAnalysisSegmentTeamDomain, (state) =>
    state.get("isLoadingRanks")
  )

export const makeSelectRanks = () =>
  createSelector(selectWidgetAnalysisSegmentTeamDomain, (state) =>
    state.get("ranks")
  )

/**
 * Default selector used by WidgetAnalysisSegmentTeam
 */

const makeSelectWidgetAnalysisSegmentTeam = () =>
  createSelector(selectWidgetAnalysisSegmentTeamDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetAnalysisSegmentTeam
export { selectWidgetAnalysisSegmentTeamDomain }
